/* const NuevIng = [
    {
        id: 0,
        recaudo: "Debes registrarte en el sistema a través de nuestra página www.iudlm.com/registro."
    },
    {
        id: 1,
        recaudo: "Ingresa a la sección ADMISIÓN."
    },
    {
        id: 2,
        recaudo: "Selecciona el periodo y la Carrera a cursar."
    },
    {
        id: 3,
        recaudo: "Llena tus datos personales."
    },
    {
        id: 4,
        recaudo: "Selecciona los documentos que debes consignar."
    },
    {
        id: 5,
        recaudo: "Por motivos de la pandemia Covid-19 solo debes adjuntar con carácter obligatorio: Fotocopia ampliada de la Cédula de Identidad y Copia de la Partida de Nacimiento."
    },
    {
        id: 6,
        recaudo: "Haz Click en el Botón ENVIAR SOLICITUD."
    },
    {
        id: 7,
        recaudo: "En la sección ESTADO DE CUENTA se reflejará el monto a cancelar y los números de cuenta para realizar el pago."
    },
    {
        id: 8,
        recaudo: "Generada la Planilla de Inscripción dispones de tres (3) días continuos para formalizar el pago. De lo contrario la inscripción será anulada."
    },
    {
        id: 9,
        recaudo: "Realiza la transferencia y registra el pago desde la opción ESTADO DE CUENTA."
    },
    {
        id: 10,
        recaudo: "En caso de PAGO EN EFECTIVO debes registrar el pago en ESTADO DE CUENTA y esperar un correo electrónico con el día que debes llevar el pago a la Institución."
    },
    {
        id: 11,
        recaudo: "Imprime la Planilla de Admisión y la Planilla de Inscripción que genera el sistema y guárdalas en la Carpeta de fibra marrón tamaño oficio junto con los demás recaudos que se señalan en la página web, para consignarlos en Control de Estudios durante la semana flexible, el día y hora que te asignen vía correo electrónico."
    }
] */

const NuevIng = [
    {
        id: 0,
        recaudo: "Carpeta marrón de fibra tamaño oficio, sin ganchos, en buen estado, identificada con una etiqueta blanca engomada o adhesiva colocada en la pestaña, indicando: número de la Cédula de Identidad, apellidos (Primero y Segundo) y nombres. (Letra Arial tamaño 10)."
    },
    {
        id: 1,
        recaudo: "Dos (2) fotografías de frente tamaño carnet, recientes e iguales, a color (no instantáneas)."
    },
    {
        id: 2,
        recaudo: "Dos (2) fotocopias de la Cédula de Identidad vigente (Ampliada en hoja tamaño carta)."
    },
    {
        id: 3,
        recaudo: "Copia de la partida de nacimiento legible, sin tachadura ni enmienda, formato actual y vigente."
    },
    {
        id: 4,
        recaudo: "Original y copia en fondo negro (en papel fotográfico) del Título de Bachiller venezolano. La copia en fondo negro debe ser autenticada al reverso (sello y firma) por la institución de origen o por la Zona Educativa respectiva en caso de que la institución haya cerrado de forma permanente (la autenticación debe ser en original)."
    },
    {
        id: 5,
        recaudo: "Original y copia, en fondo negro (en papel fotográfico) de las notas certificadas de Bachillerato de 1° a 5° año. La copia en fondo negro debe ser autenticada al reverso (sello y firma) por la institución de origen o por la Zona Educativa respectiva en caso de que la institución haya cerrado de forma permanente. (La autenticación debe ser en original)."
    },
    {
        id: 6,
        recaudo: "Copia del comprobante de preinscripción nacional, y copia de la constancia de presentación de la Prueba Nacional de Aptitud Académica (CNU) o del Registro Nacional de Ingreso (RUSNIEU)."
    },
    {
        id: 7,
        recaudo: "Copia del Registro Militar Obligatorio. Según el artículo 80 de la Ley de Conscripción y Alistamiento Militar (LCAM), si es mayor de edad, es decir, con 18 años cumplidos, está en la obligación de presentar ante la autoridad competente o ente privado correspondiente, el documento que acredite su inscripción militar o el haber cumplido con el servicio correspondiente."
    },
    {
        id: 8,
        recaudo: "Los venezolanos con estudios de bachillerato fuera del país, aunque posean Título de Bachiller extranjero, NO podrán inscribirse, a menos que hayan concluido la reválida o el reconocimiento de su título, ante el Ministerio del Poder Popular para la Educación y su debida traducción al idioma oficial, esto es, al español."
    }
]
export default NuevIng;


// WEBPACK FOOTER //
// ./src/shared/NuevIng.jsx